import { InjectionToken } from '@angular/core';
import { FingerprintAuthConfiguration } from './interfaces';

/** InjectionToken for Global Configuration */
export const Config = new InjectionToken<FingerprintAuthConfiguration>('PLUGIN_CONFIGURATION');